export default __webpack_public_path__ + "static/media/unavailable-grey.75bf30b1.svg";